import { render, staticRenderFns } from "./firstPart.vue?vue&type=template&id=4da22afc&scoped=true&"
import script from "./firstPart.vue?vue&type=script&lang=js&"
export * from "./firstPart.vue?vue&type=script&lang=js&"
import style0 from "./firstPart.vue?vue&type=style&index=0&id=4da22afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da22afc",
  null
  
)

export default component.exports